import _defineProperty from "@babel/runtime/helpers/defineProperty";
export var initialState = {
  elements: {},
  collections: {}
};
var REQUEST = 'request';
var RESPONSE = 'response';
var ERROR = 'error';
export var getStatus = function getStatus(type) {
  switch (type) {
    case 'request':
      return {
        isFetching: true,
        isError: false,
        hasData: false
      };
    case 'response':
      return {
        isFetching: false,
        isError: false,
        hasData: true
      };
    case 'error':
      return {
        isFetching: false,
        isError: true,
        hasData: false
      };
    default:
      return {
        isFetching: false,
        isError: false,
        hasData: false
      };
  }
};
var updateCollections = function updateCollections(state, res, actionType, url) {
  var _ref = res || {},
    _ref$data = _ref.data,
    data = _ref$data === void 0 ? [] : _ref$data;
  return Object.assign(Object.assign({}, state.collections), _defineProperty({}, url, Object.assign(Object.assign({}, getStatus(actionType)), {
    items: Array.isArray(data) ? data.map(function (item) {
      return item.id;
    }) : []
  })));
};
var getElements = function getElements(state, res) {
  var _ref2 = res || {},
    _ref2$data = _ref2.data,
    data = _ref2$data === void 0 ? [] : _ref2$data;
  if (!Array.isArray(data) || data.length === 0) {
    return state.elements;
  }
  var newElements = {};
  data.forEach(function (item) {
    var id = item.id;
    newElements[id] = item;
  });
  return Object.assign(Object.assign({}, state.elements), newElements);
};
var bundles = function bundles() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var _a;
  var response = action.data;
  switch (action.type) {
    case 'REQUEST_CXE_BUNDLES':
      {
        return Object.assign(Object.assign({}, state), {
          collections: updateCollections(state, response, REQUEST, action.url)
        });
      }
    case 'RECEIVE_CXE_BUNDLES':
      {
        var responseType = ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.length) ? RESPONSE : ERROR;
        return Object.assign(Object.assign({}, state), {
          elements: getElements(state, response),
          collections: updateCollections(state, response, responseType, action.url)
        });
      }
    case 'ERROR_CXE_BUNDLES':
      {
        return Object.assign(Object.assign({}, state), {
          collections: updateCollections(state, response, ERROR, action.url)
        });
      }
    default:
      return state;
  }
};
export default bundles;